import { Arrow } from '@radix-ui/react-popover';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './popover.scss';

type Props = ComponentPropsWithoutRef<typeof Arrow>;
export const PopoverArrow = (props: Props) => {
    return <Arrow data-testid="popover-arrow" {...props} className={cn('popover__arrow', props.className)} />;
};
